<template>
  <div
    v-if="rentReviewsSorted.length > 0"
  >
    <div
      id="rentReviews"
      class="flex flex-row items-center justify-between mb-6"
    >
      <div class="text-xl font-bold">Отзывы о владельце</div>
      <div
        v-if="rentReviews.length > 3"
        class="font-medium text-gray-700 cursor-pointer"
        @click="isSeeAll = !isSeeAll"
      >
        <template v-if="!isSeeAll"> Смотреть все ({{ rentReviews.length }}) </template>
        <template v-else> Скрыть </template>
      </div>
    </div>
    <div
      v-for="review in rentReviewsItems"
      :key="review.id"
      class="flex flex-row my-4"
    >
      <template v-if="review.user">
        <NuxtLink
          :to="$localePath(`/user/${review.user.id}`)"
          class="w-[44px] h-[44px] flex flex-none mr-3"
          :aria-label="`Перейти к профилю ${review.user.publicName}`"
        >
          <nuxt-img
            :src="review.user.avatar.medium"
            alt=""
            srcset=""
            class="object-cover w-full h-full rounded-full"
            loading="lazy"
          />
        </NuxtLink>
        <div class="w-full">
          <div class="flex flex-row justify-between">
            <div>
              <NuxtLink
                :to="$localePath(`/user/${review.user.id}`)"
                class="font-bold text-sm"
              >
                {{ review.user.publicName }}
              </NuxtLink>
              <div class="first-letter:uppercase text-xs text-gray-400">
                {{ $dayjs(review.createdAt).format('ll') }}
              </div>
            </div>
            <RmStars
              :id="review.id"
              :rating="review.rating"
            />
          </div>
          <div class="my-3 lg:text-base text-sm">
            {{ review.comment }}
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import RmStars from '~/components/shared/rm_stars.vue'
import { useLot } from '~/composables/useLot'

const props = defineProps({
  lotId: {
    type: [String, Number],
    default: 0,
  },
})

const { lot } = useLot(props.lotId)

const { $dayjs } = useNuxtApp()


const rentReviews = computed(() => lot.value.user?.rentReviews || [])

const isSeeAll = ref(false)

const rentReviewsSorted = computed(() => {
  const source = rentReviews.value || []
  let result = [...source]
  result = result.filter(item => item.state === 'PUBLISHED')
  result.sort(function (a, b) {
    if (a.comment && !b.comment) {
      return -2
    }
    if (!a.sortIndex && b.sortIndex) {
      return 2
    }
    if (new Date(a.createdAt) > new Date(b.createdAt)) {
      return -1
    }
    if (new Date(a.createdAt) < new Date(b.createdAt)) {
      return 1
    }
    return 0
  })
  return result
})

const slicedRentReviews = computed(() => rentReviewsSorted.value.slice(0, 3))

const rentReviewsItems = computed(() => (isSeeAll.value ? rentReviewsSorted.value : slicedRentReviews.value))
</script>
